import { Dropdown, DropDownProps } from 'antd';

export default function MPDropdown({ ...props }: DropDownProps) {
    return (
        <>
            <Dropdown {...props}>{props.children}</Dropdown>
        </>
    );
}
